module.exports = __webpack_public_path__ + "static/media/welcomeImage.6aacd802.png";